
import { useState } from "react";

export const useAuthState = (initialSignUpMode = false) => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [country, setCountry] = useState("");
  const [acceptedTerms, setAcceptedTerms] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isSignUp, setIsSignUp] = useState(initialSignUpMode);
  const [isForgotPassword, setIsForgotPassword] = useState(false);

  return {
    email,
    setEmail,
    password,
    setPassword,
    firstName,
    setFirstName,
    lastName,
    setLastName,
    country,
    setCountry,
    acceptedTerms,
    setAcceptedTerms,
    isLoading,
    setIsLoading,
    isSignUp,
    setIsSignUp,
    isForgotPassword,
    setIsForgotPassword,
  };
};
